import Template from "backbone/projects/templates/registration_skills.js.hamlc"
import ProjectsCollection from "backbone/projects/collections/projects_collection.js"
import ProjectsViewState from "backbone/projects/models/projects_view_state.js"
import ProjectsView from "backbone/projects/views/projects_view.js"

export default class RegistrationSkillsView extends Backbone.View
  events:
    "click .js-add-skills"       : "addSkills"
    "click .js-next-page"        : "nextPage"

  initialize: (options) ->
    @finishLaterUrl = options.finishLaterUrl
    @topicsUrl = options.topicsUrl
    @finishLater = false
    @render()
    @listenTo(@collection, "change", @checkStatus)

  render: ->
    @$el.html(Template(addProjectsUrl: @options.addProjectsUrl))

    @collection = new ProjectsCollection
    @viewState = new ProjectsViewState
      addSkillsMode: true
    @projectsView = new ProjectsView(
      el: @$el.find("#projects")
      skills: @options.skills
      collection: @collection
      viewState: @viewState
    )
    @collectionView = @projectsView.collectionView

  saveAndFinishLater: ->
    @finishLater = true
    @collectionView.saveAndFinishLater()

  addSkills: ->
    if @collectionView.allSkillInputsValid()
      @collectionView.saveProjectSkills()

  checkStatus: ->
    if @finishLater
      finished = @collection.noSavePending()
      nextLocation = @finishLaterUrl
    else
      finished = @collection.saveSkillsComplete()
      nextLocation = @topicsUrl

    if finished
      contently.flash.notice("All skills have been added to your projects")
      window.location = nextLocation
    else
      @showNextPageLink()

  showNextPageLink: ->
    @$el.find(".js-next-page").css("display", "inline-flex")

  nextPage: ->
    window.location = @topicsUrl



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/registration_skills_view.js.coffee